import { useState, useRef } from 'react';
import { useDisclosure } from '@chakra-ui/react';

const useTabularView = (tab, colLength) => {
    const gridApi = useRef(null);

    const addRows = useDisclosure();

    const [isInitialRequestSent, setIsInitialRequestSent] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const typeDataId = tab;
    const columnLength = colLength;

    return {
        gridApi,
        isInitialRequestSent,
        setIsInitialRequestSent,
        typeDataId,
        columnLength,
        addRows,
        isLoading,
        setIsLoading,
    };
};

export default useTabularView;
